

















import Vue from "vue";

const DIFF = -80;

let openingItem;
function touch(e) {
    
    if(openingItem && e.target) {
        const a = e.target.closest('.content');
        const b = openingItem.$refs.content.closest('.content');
        if(a === b) return;
        
        openingItem.state = 'close';
        openingItem.$refs.content.style['transform'] = 'translate(0)';
        openingItem = null;
    }
}

document.addEventListener('touchstart', touch);

export default Vue.extend({
    props: ['tag'],

    data() {
        return {
            clientX: 0,
            startX: 0,
            dx: 0,
            state: 'close',
            touching: false,
        };
    },

    methods: {
        startHandler(event) {
            const {state} = this;

            const touch = event.touches[0];
            this.startX = state === 'open' ? touch.clientX - DIFF : touch.clientX;
            this.state = 'opening';
            if(state === 'open') {
                this.$refs.content.style['transform'] = `translate(${DIFF}px)`;
            }
        },
        endHandler() {
            const {state} = this;
            if(state !== 'opening') { return; }
            let dx = this.dx;

                this.$refs.content.style['transform'] = null;
            if (dx <= DIFF) {
                this.state = 'open';
                openingItem = this;
            } else {
                this.state = 'close';
            }
        },
        movingHandler (event) {
            const {startX, state} = this;
            if(state !== 'opening') { return; }
            const touch = event.touches[0];
            let dx = touch.clientX - startX;
            if(dx >= -15) {
                dx = 0;
            // } else if(dx < DIFF) {
            //     dx = DIFF - (DIFF - dx) * 0.5;
            }
            this.$refs.content.style['transform'] = `translate(${dx}px)`;
            this.dx = dx;
        },
        onDelete() {
            this.$emit("onDelete", this.tag);
        },
    }
});
